export const PRODUCT_CONTAINER_WRAPPER = 'product_container__wrapper';
export const PRODUCTS_GRID_WRAPPER = 'products_grid__wrapper';
export const SKIP_CONTENT_TARGET_ID = 'skip-content-target-id';
